import { post, get, patch } from "@utils/axios";

const api = "auth"

export const login = (payload) => {
    return post(`${api}/signin`, payload, false);
}
export const logoutReq = (payload) => {
    return post(`${api}/signout`, payload);
}

export const forget = (payload) => {
    return post("forgot-password", payload, false);
}

export const reset = (payload) => {
    return post("reset-password", payload, false);
}

export const register = (payload) => {
    return post("register", payload, false);
}

export const getNavigationReq = (payload) => {
    return get("nav");
}

export const getProfileDetail = (username) => {
    return get(`profile/${username}`);
}

export const updatePassword = (payload) => {
    const { uuid, ...requestBody } = payload;
    if (!uuid) return
    return patch(`profile/change-password/${uuid}`, requestBody);
}

